// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1j9bZ","rootCenter":"LoadMoreObserver_rootCenter___fTNt","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1EkeD"};